export const statusAccountant = {
  style_status,
  label_status,
};


function style_status(status) {
    const styles = {
      "Pendiente": "#efac40",
      "Activo": "#49a8f3",
      "Cancelado": "#e1192d",
      "Solicitud enviada": "#ae66e4",
      "Solicitud de contador": "#ae66e4",
      "Solicitud aprobada": "#28a745",
      "Por pagar": "#f59e0b",
      "Forma pago aprobado": "#007bff",
      Inactivo: "#e1192d",
    };
    const color = styles[status] || "#e9a6ad";
    return `background-color: ${color} !important; color: #ffffff !important;`;
}

function label_status(status) {
  
  const labels = {
    "Pendiente": "Por revisar",
    "Activo": "Suscriptor asociado",
    "Cancelado": "Cotización cancelada",
    "Inactivo": "Inactivo",
    "Solicitud enviada": "Cotización enviada",
    "Solicitud de contador": "Cotización enviada por contador",
    "Solicitud aprobada": "Cotización aprobada",
    "Por pagar": "Cotización por pagar",
    "Forma pago aprobado": "Forma de pago aprobado",
  };
  return labels[status] || "Sin estatus";
}






